var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from 'vue';
// DS(branu-ai-design-system) の流体オーロラ背景 Web Component を登録する。
// side-effect import: aurora-bg.js が customElements.define('aurora-bg', ...) を実行。
// presets は bg の後に読む（AuroraBg.definePreset を使うため）。
// mode:'spa' なので client のみで評価され、WebGL/window 参照も安全。
// @ts-ignore vendored plain script (型定義なし)
import '@/assets/vendor/aurora/aurora-bg.js';
// @ts-ignore vendored plain script (型定義なし)
import '@/assets/vendor/aurora/aurora-presets.js';
// <aurora-bg> を Vue のコンポーネント解決対象から外す（Web Component として扱う）
if (!Vue.config.ignoredElements.includes('aurora-bg')) {
    Vue.config.ignoredElements = __spreadArrays(Vue.config.ignoredElements, ['aurora-bg']);
}
